(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["icafe-footer"]) return;
  try {
    
  if (!customElements.get('icafe-site-footer')) {
    customElements.define('icafe-site-footer', class extends HTMLElement {
      constructor() {
        super();
        this.updateMenus = this.updateMenus.bind(this);
      }
      connectedCallback() {
        this.viewport = window.matchMedia('(min-width: 768px)');
        this.viewport.addEventListener('change', this.updateMenus);
        this.updateMenus();
      }
      disconnectedCallback() {
        this.viewport?.removeEventListener('change', this.updateMenus);
      }
      updateMenus() {
        this.querySelectorAll('[data-footer-menu]').forEach(menu => {
          menu.open = this.viewport.matches;
          const summary = menu.querySelector('summary');
          if (summary) summary.tabIndex = this.viewport.matches ? -1 : 0;
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
